<p-toast></p-toast>
<div class="card">
    <div class="card request-solar-container p-5">
        <div class="p-fluid p-formgrid grid justify-content-center">
            <!-- <h5>{{ "WRITE_YOUR_QUERY" | translate }}</h5> -->
            <div class="field col-12 md:col-12">
                <span>{{ "Text" | translate }}</span>
                <textarea id="description" [(ngModel)]="text" placeholder="Write text here" pInputTextarea
                    required rows="4" cols="20" class="mr-3"></textarea>
            </div>
        </div>
        <div class="p-fluid p-formgrid grid justify-content-between">
            <div class="field col-12 md:col-6">
                <span>{{ "PASSWORD" | translate }}</span>
                <p-password [(ngModel)]="password" [toggleMask]="true" placeholder="Enter Password" [feedback]="false"></p-password>
            </div>

            <div class="field col-12 md:col-4">
                <span class="hide">{{ "sub" | translate }}</span>
                <button (click)="onSubmit()" pButton pRipple type="submit" label="{{'SUBMIT'| translate}}"
                    class="p-button-success mr-2 mb-2" [disabled]="false"></button>
            </div>
        </div>
    </div>

    <!-- definition data start -->
    <div class="card dashboardTable" style="margin: 5px" *ngIf="textDefinition != null">
        <div class="p-fluid p-formgrid grid justify-content-center">
            <h5>{{ "Definition" | translate }}</h5>
            <div class="field col-12 md:col-12">
                <textarea readonly id="description" [(ngModel)]="textDefinition" placeholder="definition" pInputTextarea
                    required rows="30" cols="20" class="mr-3"></textarea>
            </div>
        </div>
    </div>
    <!-- definition data end -->
</div>